<template>
  <el-row class="industryBox">
        <p>各地市申请人类型(申请量)</p>
        <div class="tag">
            <div>
              <span v-for="item in options" :key="item.value" @click="cityChange(item.value)" :class="{'active': cityValue == item.value}">{{item.value}}</span>
              <!-- <span @click="handleChangeCity('大庆市')" :class="{'active': areaName == '大庆市'}">大庆市/</span>
              <span @click="handleChangeCity('齐齐哈尔市')" :class="{'active': areaName == '齐齐哈尔市'}">齐齐哈尔市/</span>
              <span @click="handleChangeCity('佳木斯市')" :class="{'active': areaName == '佳木斯市'}">佳木斯市/</span> -->
            </div>
            <!-- <el-select
                v-model="cityValue"
                placeholder="其他地区"
                size="size"
                style="width: 110px"
                @change="cityChange"
                >
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                />
           </el-select> -->
        </div>
        <div id="industryEchart3" :style="{ width: '500px', height: '300px' }"></div>
  </el-row>
</template>

<script>
import {onMounted, onUnmounted, ref } from 'vue'
import * as echarts from "echarts";
export default {
  name: "industryEchart3",
  data(){
    return {
        deviceName: 'ele2',
    }
  },
  setup() {
    const options = [{
      value: '哈尔滨市',
      label: '哈尔滨市',
    },
    {
      value: '大庆市',
      label: '大庆市',
    },
    {
      value: '齐齐哈尔市',
      label: '齐齐哈尔市',
    },
    {
      value: '佳木斯市',
      label: '佳木斯市',
    },
    {
        value: '牡丹江市',
        label: '牡丹江市',
    },
    {
        value: '黑河市',
        label: '黑河市',
    },
    {
        value: '绥化市',
        label: '绥化市',
    },
    {
        value: '鸡西市',
        label: '鸡西市',
    },
    {
        value: '七台河市',
        label: '七台河市',
    },
    {
        value: '双鸭山市',
        label: '双鸭山市',
    },
        {
        value: '鹤岗市',
        label: '鹤岗市',
    },
    {
        value: '伊春市',
        label: '伊春市',
    },
    {
        value: '大兴安岭地区',
        label: '大兴安岭地区',
    },
    ]
    /// 声明定义一下echart
    let echart = echarts;
    let cityValue = ref('哈尔滨市');
    let areaName = ref('');
    onMounted(() => {
      industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[2464,1287,346,273,2]);
    });
    onUnmounted(() => {
      echart.dispose();
    });
    function industryEchart(xData, yData) {
      let chart = echart.init(document.getElementById("industryEchart3"));
      // 把配置和数据放这里
      chart.setOption({
        tooltip: {
          trigger: 'axis'
        },
        grid: {
          top: 10,
          bottom: '30%',
        },
        xAxis: {
            type: 'category',
            data: xData,
            axisLabel: {
              show: true, // 是否显示刻度标签，默认显示
              interval: 0, // 坐标轴刻度标签的显示间隔，在类目轴中有效；默认会采用标签不重叠的策略间隔显示标签；可以设置成0强制显示所有标签；如果设置为1，表示『隔一个标签显示一个标签』，如果值为2，表示隔两个标签显示一个标签，以此类推。
              rotate: 46, // 刻度标签旋转的角度，在类目轴的类目标签显示不下的时候可以通过旋转防止标签之间重叠；旋转的角度从-90度到90度
              inside: false, // 刻度标签是否朝内，默认朝外
              margin: 6, // 刻度标签与轴线之间的距离
              color: '#fff',
              fontSize: '14px',
            },
          },
          yAxis: {
            type: 'value',
            axisLabel: {
              color: '#fff',
              fontSize: '14px',
            },
          },
          series: [
            {
              data: yData,
              type: 'bar',
              itemStyle: {
                normal: {
                color:'#02eeea',
                label: {
                  show: true,
                  position: 'top',
                  textStyle: {
                      color: '#fff',
                      fontSize: '14px'
                  }
                }
                }
              }
            }
          ]
    });
      window.onresize = function() {
        //自适应大小
        chart.resize();
      };
    }
    function handleChangeCity(val) {
      areaName.value = val;
      if(val == '哈尔滨市') {
        industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[2464,1287,346,273,2]);
      }
      if(val == '大庆市') {
        industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[51,130,110,2,6]);
      }
      if(val == '齐齐哈尔市') {
        industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[36,72,68,0,1]);
      }
      if(val == '佳木斯市') {
        industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[20,29,30,0,2]);
      }
    }
    function cityChange(val) {
      cityValue.value = val;
      if(val == '哈尔滨市') {
        industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[2464,1287,346,273,2]);
      }
      if(val == '大庆市') {
        industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[51,130,110,2,6]);
      }
      if(val == '齐齐哈尔市') {
        industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[36,72,68,0,1]);
      }
      if(val == '佳木斯市') {
        industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[20,29,30,0,2]);
      }
      if(val == '牡丹江市') {
        industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[3,40,40,1,0]);
      }
      if(val == '黑河市') {
        industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[2,9,42,0,0]);
      }
      if(val == '绥化市') {
        industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[8,30,15,0,0]);
      }
      if(val == '鸡西市') {
        industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[5,19,15,0,0]);
      }
        if(val == '七台河市') {
        industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[0,28,8,0,0]);
      }
      if(val == '双鸭山市') {
        industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[0,5,21,0,0]);
      }
      if(val == '鹤岗市') {
        industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[1,3,14,1,1]);
      }
      if(val == '伊春市') {
        industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[0,4,7,0,0]);
      }
      if(val == '大兴安岭地区') {
        industryEchart(['大专院校','企业','个人','科研单位','机关团体'],[0,3,5,0,0]);
      }
    }
    return { areaName, cityValue, options, industryEchart, cityChange, handleChangeCity};
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* .industryBox label{
  margin-left: 10px;
  margin-top: 10px;
} */
 .tag{
  margin: 20px auto;
 }
 .tag span{
  padding: 6px;
  cursor: pointer;
  font-size: 14px;
  padding-bottom: 5px;
  width: 90px;
  display: inline-block;
  background: #004296;
  margin: 2px;
  text-align: center;
 }
 .tag span.active{
  color: #fff;
  font-weight: 500;
  font-size: 14px;
  background: #0071ff;
 }
/deep/ .el-select{
  padding-left: 5px;
}
</style>
